const GameActionTypes = {
    UPDATE_CURRENT_GAME: 'UPDATE_CURRENT_GAME',
    UPDATE_HOME_PAGE_GRIDS: 'UPDATE_HOME_PAGE_GRIDS',
    UPDATE_HOME_PAGE_GAMES: 'UPDATE_HOME_PAGE_GAMES',
};

export default GameActionTypes;